var Marionette = require('marionette'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV');

require('jqDragPane');


/*
 * Note: vm ref access through options of currentView -- make back view?
 * -- other option define region in fn in main view / set vm on before show of region.
 * Current view is always the CENTER VIEW -- not the main view -- ui layout code overlapping it put in here
 */

module.exports = Marionette.ItemView.extend({

    initialize: function(options) {

        var o = options;
        this.lChannel = o.lChannel;
        this.bindUIElements();
        this.enableDraggers( o.lChannel, o.$leftPanel, o.$rightPanel, o.$layoutViewEl );

    }, 
    ui: {
        draggerLeft:        '.dragger-left',
        draggerRight:       '.dragger-right',
        collapseRight:      '.FV-collapse.right',
        collapseLeft:       '.FV-collapse.left'
    },
    triggers: {
        'click @ui.collapseRight':      'collapseRight',
        'click @ui.collapseLeft':       'collapseLeft'
    },
    onCollapseRight: function() {
        this.lChannel.trigger('layout:closeSidePanel', 'right');
    },
    onCollapseLeft: function() {
        this.lChannel.trigger('layout:closeSidePanel', 'left');
    },

    /*
    * TODO:
    * - throttle/debounce resize panel
    * - take width of draggers into account for overflow
    * Note: layoutView must be in DOM to get $layoutViewEl.
    * */
    enableDraggers: function(lChannel, $leftPanel, $rightPanel, $layoutViewEl) {

        var $container = $layoutViewEl,

            fnScale = lChannel.request('setScaleFn'), // ( cache for performance )

            leftSideModel = lChannel.request('leftSideModel'),
            rightSideModel = lChannel.request('rightSideModel'),

            // TODO: fwd to new lChannel.request('vChannel').request('viewModeIsPdf') and check other places to do so
            // search for 'isPDF'
            modeIsPDF = function() {
                return lChannel.request('viewMode') === 'pdf';
            },
            

            modeIsSinglePage = function() {
                return lChannel.request('viewMode') === 'page';
            },
            currentPgRenderedInIframeInDocOrPageMode = function() {

                var curPg =
                    lChannel.request('vChannel').request('currentPage');  // should mediate ...

                return curPg && curPg.renderUrlViewForDocAndPageMode(); // (Doc could have no pages)

            },
            currentPgIsGos =function() {
                var curPg = lChannel.request('vChannel').request('currentPage');
                return curPg && curPg.isGOS(); // (Doc could have no pages
            },

            // ( Using functions because current page and mode may have change since init )
            fnApplyIframeFix = function() {
               
                var isPdfMode = modeIsPDF();
                return isPdfMode ||
                    ( !isPdfMode && currentPgRenderedInIframeInDocOrPageMode() ) || // cover 'url page views'
                    ( modeIsSinglePage() && currentPgIsGos() ); // cover GOS pages loaded as PDF's in page mode
            },
            
            fnSetPanelWidth = function(e, side, sideWidth) {
                lChannel.trigger('layout:setPaneWidth', side === 'left'
                    ? leftSideModel
                    : rightSideModel, sideWidth, {fromDrag: true} );
            },
            baseOpts = {

                dragStart: function() {
                    lChannel.command('setPanelIsResizing', true); // could also be forwarded event
                },

                dragEnd:  function() {
                    fnScale();
                    fnSetPanelWidth.apply(this, arguments);
                    lChannel.command('setPanelIsResizing', false);
                },

                // Note:
                // - throttle ~@ 100 can make UI look 'bumpy'
                // - repositionShapeDialog called twice if scale changes, but hardly a perf. hit
                //   ( and issue is kinda trivial so don't feel like a large refactor )
                dragMove: function() {
                    fnScale();
                    lChannel.trigger( 'layout:repositionShapeDialog' );
                },

                draggingClass: 'dragger-active',
                container: $container,
                iframeOverlayClass: 'dragger-iframe-overlay',

                /*
                 * TODO: if more, just provide all visible iframes in the viewerContainer and loop
                 * (and only request this fn if applyIframeFix is true).
                 * Note: on init pdfWrapper and docOrPgModeCurrentPgEl don't yet exist.
                 * Also -- the mode and the current page could change -- why using functions.
                 */
                $iframeContainer: function() {

                    if ( modeIsPDF() ) {
                        return lChannel.request('pdfWrapper');
                    }
                    // should mediate better here ...
                    return lChannel.request('vChannel').request('docOrPgModeCurrentPgEl');
                },

                fnApplyIframeFix: fnApplyIframeFix // (only if in PDF mode)
            };

        this.ui.draggerLeft.dragPaneResizer( _.extend({}, baseOpts, {
            leftPane: $leftPanel,
            rightPane: this.$el,
            type: 'left',
            minLeftEl: $container,
            maxRightEl: this.ui.draggerRight, //enfore on init draw ...
            minWidth: leftSideModel.minWidth
        }));

        this.ui.draggerRight.dragPaneResizer( _.extend({}, baseOpts, {
            leftPane: this.$el,
            rightPane: $rightPanel,
            type: 'right',
            minLeftEl: this.ui.draggerLeft,
            maxRightEl: $container,
            minWidth: rightSideModel.minWidth
        }));

    },
    /*
    * Only from layout (paneToggledOpen)
    * */
    updatePostSidePaneOpenChange: function(pane, isOpen) {

        var self = this;

        return $.Deferred(function($dfd) {

            if (isOpen) {

                // _.partial( _.bind(self._toggleCollapsed, self) , isOpen, pane)

                self.updatePosition( pane, function() {
                    self._toggleCollapsed(isOpen, pane).done( function() {
                        $dfd.resolve();
                    });
                });

            } else {

                self._toggleCollapsed(isOpen, pane).done( function() {
                    $dfd.resolve();
                });
            }

        }).promise();

    },
    /*
     * Only from updatePostSidePaneOpenChange
     * */
    _toggleCollapsed: function(isOpening, sideModel) { //
        var side = sideModel.get('side'),
            dragger = this.ui['dragger' + (side === 'left' ? 'Left' : 'Right')], 
            $el = this.$el;

        return $.Deferred( function($dfd) {
            $.when( dragger.toggleClass('hide'), $el.toggleClass('no-margin-' + side)).then( $dfd.resolve );
        }).promise();
    },
    /*
     * Updates the side margin (using width of the model now just setting css)
     * TODO:
     * - have update on model width change ...
     * - cb: use event instead ?
    * */
    updatePosition: function(sideModel, cb) {
        this.$el.css('margin-' + sideModel.get('side'), parseFloat( sideModel.get('width')) );
        cb && cb();
    },
    onBeforeDestroy: function() {
        Marionette.blindTriggerOn( [this.ui.draggerLeft, this.ui.draggerRight], 'destroy');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelCenter/panelCenterView.js
 ** module id = 743
 ** module chunks = 0
 **/